import IEnquiry from '@/models/interfaces/IEnquiry';
import Enquiry from '@/models/enquiry/Enquiry';
import Address from '@/models/Address';
import PurchaseTime from '@/enums/PurchaseTime';
import PersonalDetails from '@/models/PersonalDetails';
import Policy from '@/models/Policy';
import SearchQuery from '@/models/SearchQuery';
import IVehicle from '@/models/vehicle/interfaces/vehicle.d';
import OptInData from '@/models/OptInData';
import IFinance from '@/models/interfaces/IFinance';
import ExtraData from '@/models/ExtraData';
import CustomerType from '@/enums/CustomerType';
import IBusiness from '@/models/interfaces/IBusiness';
import KeyValue from '@/models/KeyValue';
import { store } from '../store';

class EnquiryBuilderService {
  private static serviceInstance: EnquiryBuilderService;

  public static get instance() {
    // eslint-disable-next-line no-return-assign
    return this.serviceInstance || (this.serviceInstance = new this());
  }

  private enquiry: IEnquiry = new Enquiry();

  public buildEnquiry(): IEnquiry {
    // Enquiry State
    const purchaseTime: PurchaseTime = store.getters['enquiryModule/purchaseTime'];
    const brochureRequested: boolean = store.getters['enquiryModule/brochureRequested'];
    const testDriveRequested: boolean = store.getters['enquiryModule/testDriveRequested'];
    const motabilityRequested: boolean = store.getters['enquiryModule/motabilityRequested'];
    const quoteRequested: boolean = store.getters['enquiryModule/quoteRequested'];
    const digitalBrochureRequested: boolean = store.getters['enquiryModule/digitalBrochureRequested'];
    const optInData: OptInData[] = store.getters['enquiryModule/optInData'];
    const extraData: ExtraData[] = store.getters['enquiryModule/extraData'];
    const customerType: CustomerType = store.getters['enquiryModule/customerType'];
    const reCaptchaToken: string | null = store.getters['enquiryModule/reCaptchaToken'];
    const rawNotes: KeyValue[] = store.getters['enquiryModule/notes'];

    let notes: string = '';
    rawNotes.forEach((x: KeyValue, index: number) => {
      if (index > 0) {
        notes += ' \n\n';
      }

      notes += `${x.key}: \n${x.value};`;
    });

    // Business State
    const business: IBusiness = store.getters['businessModule/business'];

    if (business.businessName != null && business.businessName.length === 0) {
      business.businessName = null;
    }

    // Finance State
    const finance: IFinance = store.getters['financeModule/finance'];

    // Initial Settings State
    const leadSourceGuid: string = store.getters['initialSettingsModule/leadSourceGuid'];
    const thanksPageId: number = store.getters['initialSettingsModule/thanksPageId'];
    const thanksEmailTemplateName: string = store.getters['initialSettingsModule/thanksEmailTemplateName'];
    // Policy State
    const privacyPolicyVersionId: string = store.getters['policyModule/privacyPolicyVersionId'];
    const termsPolicyVersionId: string = store.getters['policyModule/termsPolicyVersionId'];
    const marketingPolicyVersionId: string = store.getters['policyModule/marketingPolicyVersionId'];
    const partnerMarketingPolicyVersionId: string = store.getters['policyModule/partnerMarketingPolicyVersionId'];
    const fCAPolicyVersionId: string = store.getters['policyModule/fCAPolicyVersionId'];
    const servicePolicy: Policy = store.getters['policyModule/servicePolicy'];
    // Personal Details State
    const personalDetails: PersonalDetails = store.getters['personalDetailsModule/personalDetails'];
    // Search Query State
    const searchQuery: SearchQuery = store.getters['searchQueryModule/searchQuery'];
    // Address State
    const address: Address = store.getters['addressModule/address'];
    // Vehicle Enquiry state
    const vehicles: IVehicle[] = store.getters['vehicleManagementModule/vehicles'];
    // Initial Settings Data
    this.enquiry.leadSource = leadSourceGuid;
    this.enquiry.thanksPageContentId = thanksPageId;
    this.enquiry.thanksEmailTemplateName = thanksEmailTemplateName;
    this.enquiry.refererUrl = window.location.href;
    // Vehicle Data
    this.enquiry.manufacturerIds = searchQuery.manufacturerIds;
    this.enquiry.derivativeId = searchQuery.derivativeId;
    this.enquiry.rangeIds = searchQuery.rangeIds ? [searchQuery.rangeIds!] : null;
    this.enquiry.vehicleLevel = searchQuery.vehicleLevel;
    this.enquiry.vehicleType = searchQuery.vehicleType;
    this.enquiry.vehicles = vehicles;
    // Enquiry Data
    this.enquiry.purchaseTime = purchaseTime;
    this.enquiry.optInData = optInData;
    this.enquiry.extraData = extraData;
    this.enquiry.customerType = customerType;
    this.enquiry.reCaptchaToken = reCaptchaToken;
    this.enquiry.notes = notes;
    // Finance Data
    this.enquiry.finance = finance;
    // Business Data
    this.enquiry.business = business;
    // Personal Details
    this.enquiry.title = personalDetails.title;
    this.enquiry.firstName = personalDetails.firstName;
    this.enquiry.surname = personalDetails.surname;
    this.enquiry.telephone = personalDetails.telephone;
    this.enquiry.email = personalDetails.email;
    // Address Details
    this.enquiry.address = address;
    // Policy Details
    this.enquiry.privacyPolicyVersionId = privacyPolicyVersionId;
    this.enquiry.termsPolicyVersionId = termsPolicyVersionId;
    this.enquiry.servicePolicyVersionId = servicePolicy.policyVersionId;
    this.enquiry.marketingPolicyVersionId = marketingPolicyVersionId;
    this.enquiry.partnerMarketingPolicyVersionId = partnerMarketingPolicyVersionId;
    this.enquiry.fCAPolicyVersionId = fCAPolicyVersionId;
    // Service Type Data
    this.enquiry.brochureRequested = brochureRequested;
    this.enquiry.testDriveRequested = testDriveRequested;
    this.enquiry.quoteRequested = quoteRequested;
    this.enquiry.digitalBrochureRequested = digitalBrochureRequested;
    this.enquiry.motabilityRequested = motabilityRequested;

    return this.enquiry;
  }
}

// export a singleton instance in the global namespace
// eslint-disable-next-line import/prefer-default-export
export const enquiryBuilderService = EnquiryBuilderService.instance;
